var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDashboard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smart-grid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17872 0H19.6085C20.8118 0 21.7872 0.975448 21.7872 2.17872V19.6085C21.7872 20.8118 20.8118 21.7872 19.6085 21.7872H2.17872C0.975448 21.7872 0 20.8118 0 19.6085V2.17872C0 0.975448 0.975448 0 2.17872 0ZM4.35745 17.4298H17.4298V4.35745H4.35745V17.4298Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3233 0H45.753C46.9563 0 47.9318 0.975448 47.9318 2.17872V19.6085C47.9318 20.8118 46.9563 21.7872 45.753 21.7872H28.3233C27.12 21.7872 26.1445 20.8118 26.1445 19.6085V2.17872C26.1445 0.975448 27.12 0 28.3233 0ZM30.502 17.4298H43.5743V4.35745H30.502V17.4298Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17872 26.1448H19.6085C20.8118 26.1448 21.7872 27.1202 21.7872 28.3235V45.7533C21.7872 46.9566 20.8118 47.932 19.6085 47.932H2.17872C0.975448 47.932 0 46.9566 0 45.7533V28.3235C0 27.1202 0.975448 26.1448 2.17872 26.1448ZM4.35745 43.5746H17.4298V30.5022H4.35745V43.5746Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3233 26.1448H45.753C46.9563 26.1448 47.9318 27.1202 47.9318 28.3235V45.7533C47.9318 46.9566 46.9563 47.932 45.753 47.932H28.3233C27.12 47.932 26.1445 46.9566 26.1445 45.7533V28.3235C26.1445 27.1202 27.12 26.1448 28.3233 26.1448ZM30.502 43.5746H43.5743V30.5022H30.502V43.5746Z",
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dashboard.34d55906341cf5f03b83d31f351f3fb3.svg";